import { Injectable } from '@angular/core';

import { SPAConfiguration, BreakPoint, DeviceType } from 'app.configuration';
import { RenderConfiguration } from 'render/render.configuration';


@Injectable()
export abstract class SPAConfigurationService<T extends SPAConfiguration | RenderConfiguration> {

  protected innerConfig: T;

  constructor(config: T) {
    try {
      this.validateBreakpoints(config.breakpoints);
    } catch (error) {
      throw new Error(`Breakpoints provided by configuration are invalid. ${error}`);
    }
    this.innerConfig = config;
  }

  public get config(): T {
    return this.innerConfig;
  }

  protected validateBreakpoints(breakpoints: BreakPoint[]): void {
    let hasRepeatedDevices = false;
    const isDeviceSet = breakpoints.every((breakpoint: BreakPoint) => breakpoint.device.length > 0);

    Object.values(DeviceType).forEach((value: string | DeviceType) => {
      // Iterate over enums returns keys and values (ex: ['0', '1', '2', 'DESKTOP', 'TABLET' ...])
      if (!Number.isNaN(Number(value))) {
        const numRepeats = breakpoints.filter(
          (breakpoint: BreakPoint) => breakpoint.device.some((bk: DeviceType) => bk === value)
        ).length;
        hasRepeatedDevices = hasRepeatedDevices || numRepeats > 1;
      }
    });

    if (!isDeviceSet) {
      throw new Error('There are breakpoints without a device defined');
    }

    if (hasRepeatedDevices) {
      throw new Error('There are breakpoints with repeated devices');
    }
  }

}
